import "@edith/metronic/js/demo9";
import "@edith/metronic/sass/theme/demos/demo9/style.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import "../../scss/style.scss";
